import styled from "styled-components";

export const DashbaordCourseIconImage = styled.img`
  width: 50px;
  border-radius: 50%;
  height: 50px;
`;

export const DashbaordCourseHolderImage = styled.img`
  width: 20px;
  border-radius: 50%;
  height: 20px;
`;
